import { Outlet } from "react-router-dom";

function RootLayout() {
  return (
    <div className="h-screen bg-[#121212] text-gray-100">
      <Outlet />
    </div>
  );
}

export default RootLayout;
